import React, { useState } from "react";
import Layout from "../../Layout/Layout";

export default function Group() {
  const [showGroupSection, setShowGroupSection] = useState(false);
  const [isNewChannel, setIsNewChannel] = useState(false);

  return (
    <Layout
      showGroupSection={showGroupSection}
      setShowGroupSection={setShowGroupSection}
      isNewChannel={isNewChannel}
      setIsNewChannel={setIsNewChannel}
    />
  );
}
